import { createStore } from 'zustand'
import type { SolutionResponse } from './solution-response'

type SolutionStore = {
  solutionApiResponse: SolutionResponse | undefined
}

export const solutionStore = createStore<SolutionStore>((set, _get) => ({
  solutionApiResponse: undefined,
  setSolutionApiResponse: (_key: string, response: SolutionResponse) => {
    set({
      solutionApiResponse: response,
    })
  },
}))
